(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-starhome-variant-select]';

  function closeSelect(root, returnFocus = false) {
    const trigger = root.querySelector('[data-starhome-select-trigger]');
    const menu = root.querySelector('[data-starhome-select-menu]');

    if (!trigger || !menu) return;

    root.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    menu.hidden = true;

    if (returnFocus) {
      trigger.focus();
    }
  }

  function openSelect(root) {
    document
      .querySelectorAll(`${ROOT_SELECTOR}.is-open`)
      .forEach((otherRoot) => {
        if (otherRoot !== root) {
          closeSelect(otherRoot);
        }
      });

    const trigger = root.querySelector('[data-starhome-select-trigger]');
    const menu = root.querySelector('[data-starhome-select-menu]');
    const selected = root.querySelector(
      '[data-starhome-select-option].is-selected'
    );

    if (!trigger || !menu) return;

    root.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    menu.hidden = false;

    requestAnimationFrame(() => {
      const firstOption = root.querySelector(
        '[data-starhome-select-option]'
      );

      if (selected) {
        selected.focus();
      } else if (firstOption) {
        firstOption.focus();
      }
    });
  }

  function syncFromNative(root) {
    const select = root.querySelector('[data-starhome-native-select]');
    const selectedLabel = root.querySelector(
      '[data-starhome-selected-label]'
    );
    const selectedSwatch = root.querySelector(
      '[data-starhome-selected-swatch]'
    );
    const options = Array.from(
      root.querySelectorAll('[data-starhome-select-option]')
    );

    if (!select) return;

    const currentValue = select.value;

    const matchingButton = options.find(
      (button) => button.dataset.value === currentValue
    );

    options.forEach((button) => {
      const isSelected = button === matchingButton;

      button.classList.toggle('is-selected', isSelected);
      button.setAttribute(
        'aria-selected',
        isSelected ? 'true' : 'false'
      );
    });

    if (!matchingButton) return;

    if (selectedLabel) {
      const label = matchingButton.querySelector(
        '.starhome-variant-select__option-main > span:last-child'
      );

      selectedLabel.textContent =
        label?.textContent?.trim() || currentValue;
    }

    if (selectedSwatch) {
      const swatch = matchingButton.querySelector(
        '.starhome-variant-select__swatch'
      );

      selectedSwatch.innerHTML = swatch?.innerHTML || '';
    }
  }

  function chooseOption(root, optionButton) {
    const select = root.querySelector('[data-starhome-native-select]');

    if (!select || !optionButton) return;

    const nextValue = optionButton.dataset.value;

    if (!nextValue) return;

    select.value = nextValue;

    syncFromNative(root);
    closeSelect(root, true);

    select.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );

    select.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  function initRoot(root) {
    if (root.dataset.starhomeInitialized === 'true') {
      return;
    }

    const trigger = root.querySelector(
      '[data-starhome-select-trigger]'
    );
    const menu = root.querySelector(
      '[data-starhome-select-menu]'
    );
    const select = root.querySelector(
      '[data-starhome-native-select]'
    );
    const optionButtons = Array.from(
      root.querySelectorAll('[data-starhome-select-option]')
    );

    if (
      !trigger ||
      !menu ||
      !select ||
      optionButtons.length === 0
    ) {
      return;
    }

    root.dataset.starhomeInitialized = 'true';

    syncFromNative(root);

    trigger.addEventListener('click', () => {
      if (root.classList.contains('is-open')) {
        closeSelect(root);
      } else {
        openSelect(root);
      }
    });

    optionButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        chooseOption(root, button);
      });

      button.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeSelect(root, true);
          return;
        }

        if (
          event.key === 'ArrowDown' ||
          event.key === 'ArrowUp'
        ) {
          event.preventDefault();

          const direction =
            event.key === 'ArrowDown' ? 1 : -1;

          const nextIndex =
            (
              index +
              direction +
              optionButtons.length
            ) % optionButtons.length;

          optionButtons[nextIndex]?.focus();
          return;
        }

        if (event.key === 'Home') {
          event.preventDefault();
          optionButtons[0]?.focus();
          return;
        }

        if (event.key === 'End') {
          event.preventDefault();
          optionButtons[optionButtons.length - 1]?.focus();
        }
      });
    });

    select.addEventListener('change', () => {
      syncFromNative(root);
    });
  }

  function initAll(scope = document) {
    scope
      .querySelectorAll(ROOT_SELECTOR)
      .forEach((root) => {
        initRoot(root);
      });
  }

  document.addEventListener('click', (event) => {
    document
      .querySelectorAll(`${ROOT_SELECTOR}.is-open`)
      .forEach((root) => {
        if (!root.contains(event.target)) {
          closeSelect(root);
        }
      });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document
      .querySelectorAll(`${ROOT_SELECTOR}.is-open`)
      .forEach((root) => {
        closeSelect(root, true);
      });
  });

  document.addEventListener('DOMContentLoaded', () => {
    initAll();
  });

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(event.target);
    }
  );

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) {
          continue;
        }

        if (node.matches?.(ROOT_SELECTOR)) {
          initRoot(node);
        }

        initAll(node);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState !== 'loading') {
    initAll();
  }
})();